import { passwordRules } from '@/features/auth/constants/passwordRules';

type PasswordChecklistProps = {
  password: string;
};

export function PasswordChecklist({ password }: PasswordChecklistProps) {
  return (
    <div className="mt-2 space-y-1">
      {passwordRules.map((rule) => {
        const isValid = rule.test(password);
        return (
          <p
            key={rule.label}
            className={`m-0 text-left text-[12px] transition-colors ${
              isValid
                ? 'text-[#119C84]'
                : password.length > 7
                  ? 'text-red-500'
                  : 'text-[#7C8B88]'
            }`}
          >
            {rule.label}
          </p>
        );
      })}
    </div>
  );
}
